"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCreatingAssociationSelector = exports.rowIndexToBeUnlinkedSelector = exports.isDeleteAssociationDialogOpenSelctor = exports.componentToBeUnlinkedSelector = exports.isAssociatedComponentsListLoading = exports.associatedComponentsListSelector = void 0;
const associatedComponentsListSelector = (state) => {
    return state.associatedComponents.associatedComponents;
};
exports.associatedComponentsListSelector = associatedComponentsListSelector;
const isAssociatedComponentsListLoading = (state) => {
    return state.associatedComponents.isAssociatedComponentsListLoading;
};
exports.isAssociatedComponentsListLoading = isAssociatedComponentsListLoading;
const componentToBeUnlinkedSelector = (state) => {
    return state.associatedComponents.componentToBeUnlinked;
};
exports.componentToBeUnlinkedSelector = componentToBeUnlinkedSelector;
const isDeleteAssociationDialogOpenSelctor = (state) => {
    return state.associatedComponents.isDeleteAssociationModalOpen;
};
exports.isDeleteAssociationDialogOpenSelctor = isDeleteAssociationDialogOpenSelctor;
const rowIndexToBeUnlinkedSelector = (state) => {
    return state.associatedComponents.rowIndexToBeUnlinked;
};
exports.rowIndexToBeUnlinkedSelector = rowIndexToBeUnlinkedSelector;
const isCreatingAssociationSelector = (state) => {
    return state.associatedComponents.isCreatingAssociation;
};
exports.isCreatingAssociationSelector = isCreatingAssociationSelector;
